import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import { Route } from '@packages/router/lib/route';
import React from 'react';

export const $routes = {
    Home: AsyncPageRender(() => pageModule(import('./Home'))),
};

function Router() {
    return (
        <>
            <Route name={'dashboard.home'} exact path={'/'} component={ProtectedRoute($routes.Home)} />
            <Route name={'dashboard.index'} exact path={'/dashboard'} component={ProtectedRoute($routes.Home)} />
        </>
    );
}

export default Router;
